import React, { useState, useEffect } from 'react';
import SentMessagesMobile from './SentMessagesMobile';
import SentMessagesWeb from './SentMessagesWeb';

const MOBILE_BREAKPOINT = 768;

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

export default function SentMessagesRouter() {
  const width = useWindowWidth();

  return width < MOBILE_BREAKPOINT ? <SentMessagesMobile /> : <SentMessagesWeb />;
}
